var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('NavBar'),_c('v-main',{staticClass:"ma-0 print",staticStyle:{"background-color":"#efefef","height":"100%"}},[_c('v-container',{staticClass:"ma-0 pa-0",staticStyle:{"height":"100%"},attrs:{"fluid":""}},[_vm._t("default")],2)],1),_c('PageFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }